var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBar = function SvgBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.178 6.57l6.914 9.986V22h-2a1 1 0 100 2h6a1 1 0 100-2h-2v-5.444l4.775-6.898A4.5 4.5 0 1013.119 5H7.092a.999.999 0 00-.052-.316l-1-3A1 1 0 005.09 1h-2a1 1 0 000 2h1.28l.666 2H3a1 1 0 00-.822 1.57zm14.877 1.372l.95-1.373A1 1 0 0017.183 5h-2.041a2.5 2.5 0 111.913 2.942zM4.909 7l5.183 7.486L15.274 7H4.91z"
  })));
};
export default SvgBar;